import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ApiHandlerService } from 'src/app/shared/services/api-handler.service';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { API } from 'src/app/shared/services/endpoints';

@Component({
  selector: 'app-blog-detail',
  templateUrl: './blog-detail.component.html',
  styleUrls: ['./blog-detail.component.scss']
})
export class BlogDetailComponent implements OnInit {
  isNewsDetail: boolean = false
  constructor(
    public _service: ApiHandlerService,
    public toaster: ToasterService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    let footer = document.getElementsByTagName('footer');
    footer[0].classList.add('without-cars');
    if (footer[1]) {
      footer[1].classList.add('without-cars');
    }
    this.getBlogDetatils()
    this.getBlogPopularDetatils();
    this.getUrl()
  }

  ngOnDestroy() {
    let footer = document.getElementsByTagName('footer')[0];
    footer.classList.remove('without-cars');
  }

  blogData: any
  getBlogDetatils() {
    const prodId = this.route.snapshot.paramMap.get('id');

    const url = API.CMS_ENDPOINTS.GET_BLOG(prodId)
    this._service.apiGet(url).subscribe({
      next: res => {
        this.blogData = res.data;
      },
      error: err => { }
    })
  }
  blogPopular: Array<any> = [];
  getBlogPopularDetatils() {


    const url = API.CMS_ENDPOINTS.POPULAR_BLOG
    this._service.apiGet(url).subscribe({
      next: res => {
        this.blogPopular = res.data.data;

      },
      error: err => { }
    })
  }
  getUrl() {
    let paths = window.location.pathname
    let arr = paths.split('/')
    if (arr.includes('news-detail')) {
      this.isNewsDetail = true
    }
    else {
      this.isNewsDetail = false
    }

  }
}
